'use client';
import Title from './heading';
import Highlight from './highlight';
import Typography from './paragraph';
Typography.Title = Title;
Typography.Paragraph = Typography;
Typography.Highlight = Highlight;
export default Typography;
